export const validationIssueString= "Validation Issues";
export const electronicSting= "Electronic Signature: ";
export const documentString= "The document cannot be signed until the errors below are resolved.";
export const requirementsNotMetString = " Requirements not met for ";
export const pleaseSelectNextString = " Error: Please select \"Next\" on the form before signing. ";
export const signature = "Signatures";
export const requirementsNotMetGaString = " Error: An item must be selected as Addressed in ";